import axios from "axios";
import { BASE_URL } from "../components/Const/Url";
import { showToast } from "./ToastHelper";

/**
 * Update the alt text of an existing document / image.
 *
 * This is intentionally small and reusable so it can be used
 * from anywhere in the app where you already have a document ID.
 *
 * @param {number|string} documentId - ID of the document/image in the backend.
 * @param {string} altText - New alt text value to be saved.
 * @returns {Promise<null|any>} - Returns the response data on success, or null on failure.
 */
export const updateDocumentAltText = async (documentId, altText) => {
  const trimmedAltText = (altText || "").trim();

  if (!documentId) {
    console.error("updateDocumentAltText called without a valid documentId");
    showToast("error", "Image ID is missing. Cannot update alt text.");
    return null;
  }

  if (!trimmedAltText) {
    showToast("error", "Alt text cannot be empty.");
    return null;
  }

  try {
    const response = await axios.patch(
      `${BASE_URL}api/v1/auth/documents/update/${documentId}/`,
      {
        alt_text: trimmedAltText,
      }
    );

    showToast("success", "Alt text updated successfully.");

    return response?.data ?? null;
  } catch (error) {
    const apiMessage =
      error?.response?.data?.errors?.alt_text?.[0] ||
      error?.response?.data?.message ||
      "Failed to update alt text.";

    console.error("Error while updating document alt text:", error);
    showToast("error", apiMessage);

    return null;
  }
};

